module.exports = __webpack_public_path__ + "static/media/Vazir-FD.90bce2e5.woff2";